/**
 * Shared client-side flag: true while an access-token refresh is in flight.
 * The axios 401 interceptor must not call signOut during refresh, or concurrent
 * React Query 401s will terminate the session mid-extend.
 */

let refreshInProgress = false

export function setSessionRefreshInProgress(inProgress: boolean): void {
    refreshInProgress = inProgress === true
}

export function isSessionRefreshInProgress(): boolean {
    return refreshInProgress
}
